// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__43VVQ","lds-ring":"Loader_lds-ring__bIfd4"};